module.exports = __webpack_public_path__ + "img/asian-beef-1.a8ca2f99.jpg";